var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvercomingBarriers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "442.000000pt",
    height: "445.000000pt",
    viewBox: "0 0 442.000000 445.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,445.000000) scale(0.100000,-0.100000)",
    fill: "#8561C5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2135 3802 c-67 -32 -71 -38 -340 -467 -775 -1236 -1164 -1861 -1192 -1915 -61 -118 -62 -228 -2 -341 63 -118 157 -174 320 -189 127 -12 2430 -12 2607 0 104 7 133 13 180 36 70 34 133 98 169 172 25 50 28 68 28 147 -1 76 -5 99 -27 148 -23 48 -239 398 -811 1312 -55 88 -121 194 -147 235 -166 268 -431 686 -472 747 -68 99 -111 127 -202 131 -54 2 -81 -2 -111 -16z m134 -590 c60 -91 364 -579 377 -604 12 -23 12 -29 2 -32 -7 -3 -88 -7 -180 -10 -108 -4 -178 -11 -200 -20 -41 -18 -94 -73 -188 -199 -41 -55 -83 -105 -94 -113 -11 -8 -44 -14 -72 -14 -48 0 -56 3 -89 39 -41 43 -115 148 -115 163 0 19 102 185 476 776 19 28 39 52 46 52 7 0 24 -17 37 -38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvercomingBarriers);
export default __webpack_public_path__ + "static/media/overcoming-barriers.f1a3241880a985a790750d9eab7b89c7.svg";
export { ForwardRef as ReactComponent };